import Chip, { ChipProps } from '@mui/material/Chip';
import { FC } from 'react';
import { CampaignStatus } from 'types/apollo/globalTypes';

interface StatusChipProps {
  status: CampaignStatus;
  activeStatus?: CampaignStatus;
  onClick?: (status: CampaignStatus) => void;
  disabled?: boolean;
}

export const StatusChip: FC<StatusChipProps> = ({ status, activeStatus, onClick, disabled }) => {
  let label = '';
  let color: ChipProps['color'] = 'default';
  const active = activeStatus === status;

  switch (status) {
    case CampaignStatus.LIVE:
      label = 'LIVE';
      color = 'success';
      break;
    case CampaignStatus.STOPPED:
      label = 'STOPPED';
      color = 'error';
      break;
    case CampaignStatus.DRAINING:
      label = 'DRAINING';
      color = 'warning';
      break;
  }

  return (
    <Chip
      size="small"
      label={label}
      sx={{ borderRadius: '4px' }}
      disabled={!active && disabled}
      variant={active ? 'filled' : 'outlined'}
      color={active ? color : 'default'}
      onClick={onClick ? () => onClick(status) : undefined}
    />
  );
};
